
<div class="nsw-content-block">    
    <div class="nsw-content-block__content">
        <h2>About {{siteName}}</h2>
        <!-- <div class="nsw-content-block__title">About {{siteName}}</div> -->
        <p class="nsw-content-block__copy">
            {{siteDescription}}
        </p>        
        <app-site-amenities-widget [amenities]="siteAmenities"></app-site-amenities-widget>
        <h3>Patrol information</h3>
        <p>{{patrolDescription}}</p>    
    </div>
</div>
